import { IExperiment } from '../../types/experiments';

const defaultState: IExperiment[] = [];

export function experimentsReducer(state: IExperiment[] = defaultState) {
  return state;
}
